import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle} from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import React, { useState } from 'react';
import { SocketState } from './SocketState';
import { useSubscription } from '@meraki-internal/state';

const PreJSON: React.FC<{ json: any }> = ({ json }) => {
    const [isShowing, setIsShowing] = useState(true);
    if (!json){
        return null;
    }
    return (
        <>
            {isShowing && <pre>{JSON.stringify(json, null, 2)}</pre>}
            <IonButton onClick={() => setIsShowing(!isShowing)}>{isShowing ? 'Hide' : 'Show'}</IonButton>
        </>
    );
};

export const WebSocketDebugPage: React.FC = () => {
    const socketState = useInstance(SocketState);
    useSubscription(() => socketState);

    return (
        <>
            <h1>Web Socket Debug Page</h1>
            <IonCard>
                <IonCardHeader>
                    <IonCardTitle>Status {socketState.getConnectionStatus()}</IonCardTitle>
                    <IonCardSubtitle>Protocol: {socketState.getPrototocol()}</IonCardSubtitle>
                </IonCardHeader>

                <IonCardContent>
                    <PreJSON json={{
                        ...socketState,
                        socket: undefined,
                        logs: undefined,
                        subscriptions: undefined,
                        apiClient: undefined,
                        state: undefined,
                        logger: undefined,
                        events: undefined,
                        httpConfig: undefined,
                        lastFivePings: undefined
                    }} />
                    <IonButton
                        disabled={socketState.getConnectionStatus() !== 'connected'}
                        onClick={() => socketState.close()}
                    >
                        Close Connection
                    </IonButton>
                    <IonButton
                        disabled={socketState.getConnectionStatus() !== 'disconnected'}
                        onClick={() => socketState.connect()}
                    >
                        Connect
                    </IonButton>
                </IonCardContent>
            </IonCard>
            <IonCard>
                <IonCardHeader>
                    <IonCardTitle>Pings</IonCardTitle>
                </IonCardHeader>

                <IonCardContent>
                    <pre>
                        {socketState.lastFivePings.map(p => JSON.stringify({ ...p, messageId: undefined })).join('\n\n')}
                    </pre>
                </IonCardContent>
            </IonCard>
            <IonCard>
                <IonCardHeader>
                    <IonCardTitle>Logs</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <pre>
                        {socketState.logs}
                    </pre>
                </IonCardContent>
            </IonCard>
        </>

    );
};
